import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Modal } from 'antd';

import { useMutation } from '@tanstack/react-query';
import apiService from 'v2/services/api';

export interface ModalNewsRVPProps {
  available?: boolean;
}

export const ModalNewsRVP = memo(({ available }: ModalNewsRVPProps) => {
  const [opened, setOpened] = useState(false);

  const disabledInThisSession = !!sessionStorage.getItem('disabled-products-without-rvp');

  const activate = useMutation({
    mutationFn: () => apiService.put('/products-without-rvp/activate', {}).toPromise(),
    onSuccess: () => {
      toast.success('Ativação realizada com sucesso!');
      setOpened(false);
    }
  });

  const handleActivate = () => {
    activate.mutate();
  };

  const handleClose = () => {
    sessionStorage.setItem('disabled-products-without-rvp', 'true');
    setOpened(false);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  return (
    <Modal
      open={opened && available && !disabledInThisSession}
      onCancel={handleClose}
      maskClosable={false}
      title='Temos uma ferramenta poderosa e totalmente gratuita para você aproveitar!'
      footer={
        <div className='flex justify-between'>
          <Button onClick={handleClose}>Quero ativar mais tarde</Button>
          <Button type='primary' onClick={handleActivate}>
            Sim, ativar RVP!
          </Button>
        </div>
      }
    >
      <p className='mb-2!' tabIndex={-1}>
        A <b>Recuperação de Vendas Perdidas (RVP)</b> já está disponível para você, mas ainda não está ativa em seus
        produtos. Recupere vendas não finalizadas e aumente sua conversão em até <b>15%</b> sem esforço!
      </p>
      <p className='mb-2!' tabIndex={-1}>
        <b>Que tal ativar agora?</b>
      </p>
      <p className='mb-0!' tabIndex={-1}>
        <i>Você pode alterar essa configuração a qualquer momento na edição de cada produto.</i>
      </p>
    </Modal>
  );
});
